var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Box",
    [
      _c("VueDatePicker", {
        attrs: {
          value: _vm.date,
          "value-type": "YYYY/MM/DD",
          placeholder: _vm.placeholder,
          disabled: _vm.disabled,
          "disabled-date": _vm.disabledDates,
          range: _vm.range,
          clearable: _vm.clearable
        },
        on: {
          input: function($event) {
            return _vm.emit($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }